@if (config) {
  <div
    class="form-control__wrapper"
    [ngClass]="{ 'form-control__wrapper--flat': direction === 'filter' }"
  >
    <label class="form-control__label">
      <p class="t-data t-bold">{{ config.label }}</p>
    </label>
    <div class="form-control" (click)="menuOpen = !menuOpen">
      @if (selectedIcon) {
        <div class="u-flex u-alignCenter">
          <icon
            class="si__icon"
            [name]="selectedIcon.value"
            [config]="{
              format: 'svg',
              size: 'medium',
            }"
          >
          </icon>
          <p class="t-data">{{ selectedIcon.label }}</p>
        </div>
      } @else {
        <div class="u-flex u-alignCenter">
          <div class="si__swatch"></div>
          <p>No Icon</p>
        </div>
      }
      <ng-template #placeholder>
        <div class="u-flex u-alignCenter">
          <div class="si__swatch"></div>
          <p>No Icon</p>
        </div>
      </ng-template>
    </div>
    @if (menuOpen) {
      <div class="form-control__menu">
        <div
          class="form-control__menu__option"
          [ngClass]="{ 'is-active': !selectedIcon }"
          (click)="selectIcon(null)"
        >
          <ng-template [ngTemplateOutlet]="placeholder"></ng-template>
        </div>
        @for (icon of icons; track icon; let i = $index) {
          <div
            class="form-control__menu__option"
            [ngClass]="{ 'is-active': icon === selectedIcon }"
            (click)="selectIcon(icon)"
          >
            <div class="u-flex u-alignCenter">
              <icon
                class="si__icon"
                [name]="icon.value"
                [config]="{
                  format: 'svg',
                  size: 'medium',
                }"
              >
              </icon>
              <p class="t-data">{{ icon.label }}</p>
            </div>
          </div>
        }
      </div>
    }
  </div>
}

@if (menuOpen) {
  <div class="modal__mask" (click)="menuOpen = false"></div>
}
